import Vue from 'vue'
import VueRouter from 'vue-router'

import Landing from '@/pages/Landing'
import About from '@/pages/About'
import LocateUs from '@/pages/LocateUs'
import NotFound from '@/pages/NotFound'

Vue.use(VueRouter)

var vueRouter = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      id: 0,
      title: 'Landing',
      component: Landing
    },
    {
      path: '/about',
      name: 'about',
      id: 1,
      title: 'About',
      component: About
    },
    {
      path: '/locate',
      name: 'locate',
      id: 2,
      title: 'Locate',
      component: LocateUs
    },
    {
      path: '*',
      name: 'notfound',
      id: 404,
      title: 'Not Found',
      component: NotFound
    }
  ]
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js